<select [ngModel]="value" (ngModelChange)="changeValue($event)">
    <option style="background-color: white;" value="white"></option>
    <option style="background-color: red;" value="red"></option>
    <option style="background-color: yellow;" value="yellow"></option>
    <option style="background-color: lightgreen;" value="lightgreen"></option>
    <option style="background-color: green;" value="green"></option>
    <option style="background-color: lightblue;" value="lightblue"></option>
    <option style="background-color: blue;" value="blue"></option>
    <option style="background-color: violet;" value="violet"></option>
    <option style="background-color: purple;" value="purple"></option>
    <option style="background-color: black;" value="black"></option>
</select>